import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class FilterHelper {

    constructor() { }

    customFieldFilterParams(customField): string{

        if (customField.type !== 'MULTI_ITEM') {
            return JSON.stringify({ label: customField.label, value: customField.value });
        }
        if (customField.type === 'MULTI_ITEM') {
            const cfData = { label: customField.label, value: '' };
            const checkBoxData = [];
            customField.options.forEach((checkBox) => {
                if (checkBox.value) {
                    checkBoxData.push(checkBox.key);
                }
            });
            cfData.value = checkBoxData.toString();
            return JSON.stringify(cfData);
        }
    }
}
